import { Toast } from 'bootstrap';

document.addEventListener("DOMContentLoaded", function() {
  const clientsManagement = document.querySelector(".users_management");
  if (clientsManagement === null) {
    return
  };

  function transformScroll(event) {
    const allScrollContainers = document.querySelectorAll('.scroll-container');
    const currentContainer = event.currentTarget;
    
    // Check if any container can scroll horizontally
    const canScrollHorizontally = Array.from(allScrollContainers).some(container => {
      return container.scrollLeft > 0 || 
             container.scrollLeft < (container.scrollWidth - container.clientWidth);
    });
    
    if (canScrollHorizontally) {
      const scrollDelta = event.deltaY + event.deltaX;
      
      // Apply scroll to all containers
      allScrollContainers.forEach(container => {
        container.scrollLeft += scrollDelta;
      });
      
      event.preventDefault();
    }
  }

  let elements = document.querySelectorAll('.scroll-container');
  elements.forEach(element => {
    element.addEventListener('wheel', transformScroll, { passive: false });
  });

  function showHideName(e) {
    let element = e.target;
    let newName = element.dataset.name;
    let oldName = element.textContent;
    element.textContent = newName;
    element.dataset.name = oldName;
    element.classList.toggle('min-width-200');
  }

  function handleTextTruncation(elements) {
    elements.forEach(element => {
        element.addEventListener('click', showHideName);
    });
  }

  const userNames = document.querySelectorAll('.show-user-name');

  handleTextTruncation(userNames);

  const inputUser = document.querySelector('.user-search');
  const resultUsers = document.querySelector('.user-search-result');
  const searchButton = document.querySelector('.search-button');

  searchButton.addEventListener('click', () => {
    let url = `/admin/users`;
    const params = new URLSearchParams();

    if (inputUser.value && inputUser.value.trim() !== '') {
      if (inputUser.dataset.userId) params.append('user_id', inputUser.dataset.userId);
      params.append('user_query', inputUser.value);
    }

    window.location.href = `${url}?${params.toString()}`;
  });

  userOrClientSearchPopup(inputUser, fetchUsers);
  hideOnBlur(inputUser, resultUsers);

  let timeoutId = null
  function userOrClientSearchPopup(inputElement, fetchFunction) {
    inputElement.addEventListener('input', (e) => {
      const searchText = e.target.value.trim();
  
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
  
      timeoutId = setTimeout(function() {
        fetchFunction(searchText);
      }, 500);
    });
  }

  function hideOnBlur(inputElement, resultElement) {
    inputElement.addEventListener('blur', (e) => {
      setTimeout(() => {resultElement.classList.add('d-none');}, 150);
    });
  }

  function fetchUsers(searchText) {
    fetch(`/admin/users/search?query=${searchText}&company_only=true`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(users => {
      renderUsers(users);
    })
    .catch(error => {
      console.error('Error fetching users:', error);
    });
  }

  function renderUsers(users) {
    inputUser.dataset.userId = '';
    resultUsers.classList.remove('d-none');
    resultUsers.innerHTML = '';

    users.forEach(user => {
      const userElement = document.createElement('div');
      userElement.classList.add('user-result-item');
      let alias_name =  '';
      if (user.user_name_aliases.length > 0 && user.user_name_aliases[0].name !== '') {
        alias_name = `(${user.user_name_aliases[0].name}) `;
      }

      userElement.textContent = `${alias_name}${user.name || user.email}`;
      userElement.dataset.userId = user.id;

      userElement.addEventListener('click', function() {
        inputUser.value = user.name || user.email;
        inputUser.dataset.userId = user.id;

        inputUser.dataset.allData = JSON.stringify(user);
        resultUsers.innerHTML = ''; // Clear results after selection
      });

      resultUsers.appendChild(userElement);
    });
  }

  const forms = document.querySelectorAll('.user-form');

  if (forms.length > 0) {
    forms.forEach(form => {
      form.addEventListener('ajax:success', (event) => {
        const [data, status, xhr] = event.detail;
        // Handle successful form submission
        document.querySelector('#toast-notification .toast-body').textContent = 'ユーザーは正常に更新されました';
        const toastElement = document.getElementById('toast-notification');
        const toast = new Toast(toastElement);
        toast.show();
      });
  
      form.addEventListener('ajax:error', (event) => {
        const [data, status, xhr] = event.detail;
        // Handle failed form submission

        document.querySelector('#toast-notification .toast-body').textContent = 'ユーザーの更新に失敗しました';
        const toastElement = document.getElementById('toast-notification');
        const toast = new Toast(toastElement);
        toast.show();
      });
    })
  }

  // Save All Users functionality
  function collectAllFormData() {
    const forms = document.querySelectorAll('form.user-form');
    const usersData = [];
    
    forms.forEach(form => {
      // Check if this is actually a form element
      if (form.tagName !== 'FORM') {
        console.error('Expected FORM element, got:', form.tagName);
        return;
      }
      
      const formData = new FormData(form);
      const userData = {};
      
      // Convert FormData to nested object structure
      for (let [key, value] of formData.entries()) {
        if (key.includes('inspector_attributes')) {
          if (!userData.inspector_attributes) userData.inspector_attributes = {};
          const inspectorKey = key.replace('user[inspector_attributes][', '').replace(']', '');
          userData.inspector_attributes[inspectorKey] = value;
        } else if (key.includes('user_name_aliases_attributes')) {
          if (!userData.user_name_aliases_attributes) userData.user_name_aliases_attributes = {};
          const aliasMatch = key.match(/user\[user_name_aliases_attributes\]\[(\d+)\]\[(.*)\]/);
          if (aliasMatch) {
            const aliasIndex = aliasMatch[1];
            const aliasKey = aliasMatch[2];
            if (!userData.user_name_aliases_attributes[aliasIndex]) {
              userData.user_name_aliases_attributes[aliasIndex] = {};
            }
            userData.user_name_aliases_attributes[aliasIndex][aliasKey] = value;
          }
        } else if (key.startsWith('user[')) {
          const userKey = key.replace('user[', '').replace(']', '');
          userData[userKey] = value;
        }
      }
      
      // Add user ID from form action URL
      const userIdMatch = form.action.match(/\/admin\/users\/(\d+)/);
      if (userIdMatch) {
        userData.id = userIdMatch[1];
        usersData.push({ user: userData });
      } else {
        console.error('Could not extract user ID from form action:', form.action);
      }
    });
    
    return usersData;
  }
  
  function showToast(message, type = 'success') {
    const toastBody = document.querySelector('#toast-notification .toast-body');
    toastBody.textContent = message;
    
    const toastElement = document.getElementById('toast-notification');
    const toast = new Toast(toastElement);
    toast.show();
  }
  
  function saveAllUsers() {
    const saveButton = document.getElementById('save-all-users');
    const originalText = saveButton.textContent;
    saveButton.disabled = true;
    saveButton.textContent = '保存中...';
    
    console.log('Starting bulk save...');
    const usersData = collectAllFormData();
    console.log('Collected user data:', usersData);
    
    fetch('/admin/users/bulk_update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ users: usersData })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        showToast(`${data.success_count}件のユーザーを正常に更新しました`, 'success');
        if (data.failed_count > 0) {
          setTimeout(() => {
            showToast(`${data.failed_count}件の更新に失敗しました`, 'error');
          }, 2000);
        }
      } else {
        showToast('一括更新に失敗しました', 'error');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      showToast('一括更新に失敗しました', 'error');
    })
    .finally(() => {
      saveButton.disabled = false;
      saveButton.textContent = originalText;
    });
  }
  
  // Add event listener for Save All button
  const saveAllButton = document.getElementById('save-all-users');
  if (saveAllButton) {
    saveAllButton.addEventListener('click', saveAllUsers);
  }
});
